/** Evita loop infinito se o reload não resolver (ex.: chunk em falta no servidor). */
const CHUNK_RELOAD_SESSION_KEY = "auction_chunk_auto_reload_done";

/**
 * @param {() => Promise<unknown>} importFn retorno de () => import('...')
 * @returns {Promise<unknown>}
 */
async function importWithRetry(importFn) {
  try {
    return await importFn();
  } catch (err) {
    if (!isChunkLoadFailure(err)) {
      throw err;
    }
    try {
      return await importFn();
    } catch (err2) {
      const alreadyReloaded = sessionStorage.getItem(CHUNK_RELOAD_SESSION_KEY);
      if (!alreadyReloaded) {
        sessionStorage.setItem(CHUNK_RELOAD_SESSION_KEY, "1");
        window.location.reload();
        return new Promise(() => {});
      }
      throw err2;
    }
  }
}

/**
 * Para usar com React.lazy: lazy(() => lazyImportModule(() => import("./Page.jsx")))
 * @param {() => Promise<unknown>} importFn
 */
export function lazyImportModule(importFn) {
  return importWithRetry(importFn);
}

/** @param {unknown} error */
export function isChunkLoadFailure(error) {
  if (!error || typeof error !== "object") return false;
  const msg = "message" in error && typeof error.message === "string" ? error.message : "";
  const name = "name" in error && typeof error.name === "string" ? error.name : "";
  return (
    name === "ChunkLoadError" ||
    msg.includes("Failed to fetch dynamically imported module") ||
    msg.includes("Importing a module script failed")
  );
}
